import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

export function useServiceWorkerUpdate() {
  const { t } = useTranslation();

  const {
    offlineReady: [offlineReady],
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('✅ Service Worker registrado:', r);
      
      // Force cache cleanup on first load
      if (r && 'caches' in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            if (cacheName.includes('workbox') || cacheName.includes('pwa')) {
              console.log('🧹 Limpando cache antigo:', cacheName);
              caches.delete(cacheName);
            }
          });
        });
      }
      
      r && setInterval(() => {
        r.update();
      }, 60000);
    },
    onRegisterError(error) {
      console.error('❌ Erro ao registrar Service Worker:', error);
    },
  });

  // Mensagem de offline ready removida conforme solicitação

  useEffect(() => {
    if (needRefresh) {
      toast.info(t('pwa.update_available'), {
        description: t('pwa.update_description'),
        action: {
          label: t('pwa.update_button'),
          onClick: () => {
            updateServiceWorker(true);
          },
        },
        duration: Infinity,
      });
    }
  }, [needRefresh, t, updateServiceWorker]);

  return { needRefresh, updateServiceWorker };
}
